import { useNavigate } from "react-router-dom";

import { ColocaResourceLink } from "@/shared/components/data-display/ColocaResourceLink";
import useTranslations from "@/shared/lang/useTranslations";

import { HolderAvatar } from "./HolderAvatar";

type HolderCardLinkProps = {
  holder: string;
  holderId?: string | null;
  email?: string | null;
};

export const HolderCardLink = ({ holder, holderId, email }: HolderCardLinkProps) => {
  const { t } = useTranslations("cards");
  const navigate = useNavigate();

  return (
    <ColocaResourceLink
      visual={<HolderAvatar name={holder} tier="verified" verified size={40} />}
      label={t("card_detail_info_holder")}
      title={holder}
      subtitle={email ?? undefined}
      onClick={holderId ? () => navigate(`/app/cards/identities/${holderId}`) : undefined}
    />
  );
};
